const appConfig = {
  title: "Treelang",
  titleColor: "blue",
  minimumNumberOfLeaves: 5,
  testNumberOfQuestions: 10,
};

export default appConfig;
